import React from 'react';
import { Quote } from 'lucide-react';
interface TestimonialProps {
  quote: string;
  author: string;
  age: number;
}
export function TestimonialCard({
  quote,
  author,
  age
}: TestimonialProps) {
  return <div className="bg-[#F9F4EF] p-8 rounded-xl border border-[#D4A5A5]/20 relative" data-id="element-163">
      <Quote className="absolute top-6 left-6 text-[#D4A5A5]/30 w-10 h-10" data-id="element-164" />
      <p className="text-[#5C4033] font-serif text-lg italic mb-6 relative z-10 pt-4" data-id="element-165">
        "{quote}"
      </p>
      <div className="flex items-center gap-3" data-id="element-166">
        <div className="w-10 h-10 rounded-full bg-[#D4A5A5] flex items-center justify-center text-white font-serif font-bold" data-id="element-167">
          {author[0]}
        </div>
        <div data-id="element-168">
          <p className="text-[#5C4033] font-bold text-sm" data-id="element-169">{author}</p>
          <p className="text-[#8B7355] text-xs" data-id="element-170">{age} años</p>
        </div>
      </div>
    </div>;
}